import { useSelector } from 'react-redux'

export const getPreSeasonActivity = (activityTitle) => {
  const { preseason } = useSelector((state) => state.newPreSeason)
  return preseason?.preSeason.activities.find((t) => t.title === activityTitle)
}
